import React from 'react'
import PropTypes from 'prop-types'
import SupplierItem from '../components/SupplierItem'

const Suppliers = ({suppliers}) => (
  <div>
    {
        suppliers.forEach((supplier, i) => {
            supplier.idx = i+1
            supplier.key = supplier.idx
        }
                )
    }
    {
        suppliers.map((supplier, i) => 
      <SupplierItem supplier={supplier} />
    )}
   </div>
)

Suppliers.propTypes = {
        suppliers: PropTypes.array.isRequired
}

export default Suppliers



// WEBPACK FOOTER //
// ./src/components/Suppliers.js